class VendorPair {
    public name:string;
    public value: string;

    constructor(name : string, value : string){
        this.name = name;
        this.value = value;
    }
}

export class GameVendors {

   private listVendor: VendorPair[] = [];

   // pass config from backend
   constructor(vendors: object) 
   {
        // convert keys to array, so it can be matched later
        for (const [key, value] of Object.entries(vendors)) {
                value.forEach((valueInner) => {
                    this.listVendor.push(new VendorPair(key, valueInner))
                })
        }
   }

   public matchVendor(nameFromBackend: string) : string {
       let nameFromFrontend =  this.listVendor.find((entry) => entry.value == nameFromBackend);

       return nameFromFrontend != undefined ? nameFromFrontend.name : "none";
   }

}
